/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_Round_Days_InvalidInputs */

const en_us2_club_round_days_invalid = /** @type {(inputs: Club_Round_Days_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A round lasts 7 to 56 days.`)
};

const pt_br2_club_round_days_invalid = /** @type {(inputs: Club_Round_Days_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma rodada dura de 7 a 56 dias.`)
};

const es_419_club_round_days_invalid = /** @type {(inputs: Club_Round_Days_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una ronda dura de 7 a 56 días.`)
};

const pt_pt2_club_round_days_invalid = /** @type {(inputs: Club_Round_Days_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma ronda dura de 7 a 56 dias.`)
};

const fr_fr2_club_round_days_invalid = /** @type {(inputs: Club_Round_Days_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une manche dure de 7 à 56 jours.`)
};

const de_de2_club_round_days_invalid = /** @type {(inputs: Club_Round_Days_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Runde dauert 7 bis 56 Tage.`)
};

const it_it2_club_round_days_invalid = /** @type {(inputs: Club_Round_Days_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un turno dura da 7 a 56 giorni.`)
};

/**
* | output |
* | --- |
* | "A round lasts 7 to 56 days." |
*
* @param {Club_Round_Days_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_round_days_invalid = /** @type {((inputs?: Club_Round_Days_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_Round_Days_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_round_days_invalid(inputs)
	if (locale === "es-419") return es_419_club_round_days_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_club_round_days_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_club_round_days_invalid(inputs)
	if (locale === "de-DE") return de_de2_club_round_days_invalid(inputs)
	if (locale === "it-IT") return it_it2_club_round_days_invalid(inputs)
	return en_us2_club_round_days_invalid(inputs)
});
export { club_round_days_invalid as "club.round_days_invalid" }